import { render, staticRenderFns } from "./templateTag.vue?vue&type=template&id=2292b195&scoped=true&"
import script from "./templateTag.vue?vue&type=script&lang=js&"
export * from "./templateTag.vue?vue&type=script&lang=js&"
import style0 from "./templateTag.vue?vue&type=style&index=0&id=2292b195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2292b195",
  null
  
)

export default component.exports